module.exports = __webpack_public_path__ + "fonts/MullerBlack.3d5f82f6.ttf";